import moment from 'moment';
import { twentyFourHourTimePadded } from '../../../constants/timezone-format';

export const isOutsideDateRange = (day) => moment().isAfter(day, 'day') || moment().add(7, 'days').isBefore(day, 'day');
export const defaultTime = moment().format(twentyFourHourTimePadded);
